import { useQuery } from '@tanstack/react-query';
import { supabase, toError } from '../supabase';

export const useUserPapersQuery = (userId?: string, enabled = true) => {
    return useQuery({
        queryKey: ['papers', 'user', userId],
        queryFn: async () => {
            if (!userId) return [];

            console.log('🔍 [UserPapersQuery] Fetching user papers...');
            const { data, error } = await supabase
                .from('papers')
                .select(`
                    *,
                    subfield:subfields(id, name, slug, field_id)
                `)
                .eq('user_id', userId)
                .order('created_at', { ascending: false });

            if (error) {
                console.error('💥 [UserPapersQuery] Error fetching user papers:', error);
                throw toError(error);
            }

            console.log(`📊 [UserPapersQuery] Found ${data.length} user papers.`);
            return data || [];
        },
        enabled: !!userId && enabled,
    });
};
